import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { PDFViewer } from '@react-pdf/renderer';
import color from '../../../../../assets/css/colors';
const useStyles = makeStyles(() => ({
  pdfViewerWrapper: {
    width: '100%',
    minWidth: 900,
    height: 700,
    border: '1px solid ' + color.gray.opacity,
  },
}));
const FormPDFApplication = (props) => {
  const classes = useStyles();

  return (
    <div id="pdf">
      <PDFViewer className={classes.pdfViewerWrapper}>{props.document}</PDFViewer>
    </div>
  );
};

export default FormPDFApplication;
